import * as Store from './constants';
import { KORREKTURWERTE } from './constants';
import PARSED_XML_DATA from '../data/data.js';
import SVG_DATA from '../data/svgdata.js';

/**
 * Fetches all bubble texts according to the result
 */
export const getBubbleDescriptions = (state, description) => {
    const bubblesTexts = [[], [], [], [], [], [], [], [], []];
    const bubblesMapping = {
        'Külgnev ruum': Store.XML_BUBBLE_ANGRENZENDER_RAUM,
        'Room located diagonally below': Store.XML_BUBBLE_DIAGONAL_DARUNTERLIEGENDER_RAUM,
        'GIS Elemente': Store.XML_BUBBLE_DUOFIX_GIS_KOMBIFIX_ELEMENTE,
        'Duofix Elemente': Store.XML_BUBBLE_DUOFIX_GIS_KOMBIFIX_ELEMENTE,
        'Kombifix Elemente': Store.XML_BUBBLE_DUOFIX_GIS_KOMBIFIX_ELEMENTE,
        Massivwand: Store.XML_BUBBLE_TRENNWAND,
        Trockenbauwand: Store.XML_BUBBLE_TRENNWAND,
        Vorwand_Beplankung: Store.XML_BUBBLE_VORWAND,
        Schallschutzset: Store.XML_BUBBLE_SCHALLSCHUTZ_SET,
    };
    

    Object.keys(description).forEach(key => {
        if (typeof bubblesTexts[bubblesMapping[key]] === 'undefined') {
            //console.error(`${key} is not defined`);
            return;
        } else {
            bubblesTexts[bubblesMapping[key]].push(description[key]);
        }
    });
    //tryout basiswand aenderung 2020-01-21
   // console.log(state.choices["wandaufbau"]);
    if(state.choices["wandaufbau"]=='vorwandinstallation_vor_massiver_trennwand'||state.choices["wandaufbau"]=="montageelement_gemauerter_vorwand"){
      
    bubblesTexts[Store.XML_BUBBLE_TRENNWAND].pop(); 
       bubblesTexts[Store.XML_BUBBLE_TRENNWAND].push([`${getSteinsorteValue(state).name}`]); 
    }else{
       
    }

    
    //unveraenderter  bubblestextbereich
    bubblesTexts[Store.XML_BUBBLE_ENTWAESSERUNG_FALLLEITUNG].push([`Äravoolusüsteemi püstik on Äravoolusüsteemid
    : ${getAbwasserFallLeitungValue(state).label}  (tuletõkkega)`]);
    bubblesTexts[Store.XML_BUBBLE_ENTWAESSERUNG_ANSCHLUSSLEITUNG].push([
        `Harutorud on Äravoolusüsteemid: ${getAbwasserAnschlussLeitungValue(state).label}`,
    ]);



    bubblesTexts[Store.XML_BUBBLE_TRINKWASSER_LEITUNG].push([
        `Veevarustussüsteemi püstik on Veevarustussüsteemi: ${getTrinkwasserSteigstrangValue(state).label}  (tuletõkkega)`,
        `Harutorud on Veevarustussüsteemi: ${getTrinkwasserAnschlussLeitungValue(state).label}  (tuletõkkega)`,
    ]);
    return bubblesTexts;
};

/**
 * Calculates all values according to the selected form fields. looks up the parsed xml definitions
 */
export const getResultValues = state => {
    const installationsSystemValue = getInstallationssystemValue(state);
    const wandaufbauValue = getWandaufbauValue(state);

    const abwasserFallLeitungValue = getAbwasserFallLeitungValue(state);
    const abwasserAnschlussLeitungValue = getAbwasserAnschlussLeitungValue(state);

    // mapping from constants to xml parsed values
    const mapping = {
        default: '',
        [Store.GEBERIT_SILENT_PRO]: 'Silent-Pro',
        [Store.GEBERIT_SILENT_DB20]: 'Silent-db20',
        [Store.GEBERIT_SILENT_PP]: 'Silent-PP',
    };

    const mappedAbwasserFallLeitungValue = mapping[abwasserFallLeitungValue.value];
    const mappedAbwasserAnschlussLeitungValue = mapping[abwasserAnschlussLeitungValue.value];

    const itemHasRohrleitungen = item =>
        item.entWaesserungFallLeitung.includes(mappedAbwasserFallLeitungValue) === true &&
        item.entWaesserungAnschlussLeitung.includes(mappedAbwasserAnschlussLeitungValue) === true;
     

    let results = {};
    const combination = `${installationsSystemValue.value}_${wandaufbauValue.value}`;
    switch (combination) {
        case `${Store.INSTALLATIONSSYSTEM_GEBERIT_GIS}_${Store.WANDAUFBAU__VORWANDINSTALLATION_VOR_MASSIVER_TRENNWAND}`:
            results = PARSED_XML_DATA.find(item => Store.XML_SEARCH_GIS_VORWAND_VOR_MASSIVER_TRENNWAND.every(r => item.wandtypen.includes(r)) && itemHasRohrleitungen(item));
            break;
        case `${Store.INSTALLATIONSSYSTEM_GEBERIT_GIS}_${Store.WANDAUFBAU__VORWANDINSTALLATION_VOR_TROCKENBAUWAND}`:
            results = PARSED_XML_DATA.find(item => Store.XML_SEARCH_GIS_VORWAND_VOR_TROCKENBAUWAND.every(r => item.wandtypen.includes(r)) && itemHasRohrleitungen(item));
            break;
        case `${Store.INSTALLATIONSSYSTEM_GEBERIT_GIS}_${Store.WANDAUFBAU__RAUMABSCHLIESSENDE_TROCKENBAUWAND}`:
            results = PARSED_XML_DATA.find(item => Store.XML_SEARCH_GIS_RAUMHOHE_TRENNWAND.every(r => item.wandtypen.includes(r)) && itemHasRohrleitungen(item));
            break;
        case `${Store.INSTALLATIONSSYSTEM_GEBERIT_GIS}_${Store.WANDAUFBAU__VORWANDINSTALLATION_GEBERIT_DUOFIX}`:
            results = PARSED_XML_DATA.find(item => Store.XML_SEARCH_GIS_VORWAND_VOR_DUOFIX_SYSTEMWAND.every(r => item.wandtypen.includes(r)) && itemHasRohrleitungen(item));
            break;
        case `${Store.INSTALLATIONSSYSTEM_GEBERIT_DUOFIX}_${Store.WANDAUFBAU__VORWANDINSTALLATION_VOR_MASSIVER_TRENNWAND}`:
            results = PARSED_XML_DATA.find(item => Store.XML_SEARCH_DUOFIX_VORWAND_VOR_MASSIVER_TRENNWAND.every(r => item.wandtypen.includes(r)) && itemHasRohrleitungen(item));
            break;
        case `${Store.INSTALLATIONSSYSTEM_GEBERIT_DUOFIX}_${Store.WANDAUFBAU__VORWANDINSTALLATION_VOR_TROCKENBAUWAND}`:
            results = PARSED_XML_DATA.find(item => Store.XML_SEARCH_DUOFIX_VORWAND_VOR_TROCKENBAUWAND.every(r => item.wandtypen.includes(r)) && itemHasRohrleitungen(item));
            break;
        case `${Store.INSTALLATIONSSYSTEM_GEBERIT_DUOFIX}_${Store.WANDAUFBAU__RAUMABSCHLIESSENDE_TROCKENBAUWAND}`:
            results = PARSED_XML_DATA.find(item => Store.XML_SEARCH_DUOFIX_ALS_RAUMHOHE_TROCKENBAUTRENNWAND.every(r => item.wandtypen.includes(r)) && itemHasRohrleitungen(item));
            break;
        case `${Store.INSTALLATIONSSYSTEM_GEBERIT_DUOFIX}_${Store.WANDAUFBAU__VORWANDINSTALLATION_GEBERIT_DUOFIX}`:
            results = PARSED_XML_DATA.find(item => Store.XML_SEARCH_DUOFIX_VORWAND_VOR_DUOFIX_SYSTEMWAND.every(r => item.wandtypen.includes(r)) && itemHasRohrleitungen(item));
            break;
        case `${Store.INSTALLATIONSSYSTEM_GEBERIT_DUOFIX}_${Store.WANDAUFBAU__MONTAGEELEMENT_RAUMABSCHLIESSENDE_TROCKENBAUWAND}`:
            results = PARSED_XML_DATA.find(item => Store.XML_SEARCH_DUOFIX_IN_TROCKENBAUTRENNWAND.every(r => item.wandtypen.includes(r)) && itemHasRohrleitungen(item));
            break;
        case `${Store.INSTALLATIONSSYSTEM_GEBERIT_KOMBIFIX}_${Store.WANDAUFBAU__MONTAGEELEMENT_GEMAUERTER_VORWAND}`:
            results = PARSED_XML_DATA.find(item => Store.XML_SEARCH_KOMBIFIX_IN_MASSIVER_VORWAND_VOR_MASSIVER_TRENNWAND.every(r => item.wandtypen.includes(r)) && itemHasRohrleitungen(item));
            break;
        default:
            console.error(combination + ' not found');
    }
    // grenzwerte din normen
    const EB_VDI_4100_2012_10_SST_EB_I=35;
    const EB_VDI_4100_2012_10_SST_EB_II=30;
    const MFH_DIN_409_1_2016_07 = 30;
    const MFH_DIN_4109_BEIBLATT_2_1989_11 = 25;
    const MFH_VDI_4100_2012_10_SST_I = 30;
    const MFH_VDI_4100_2012_10_SST_II = 27;
    const MFH_VDI_4100_2012_10_SST_III = 24;
    const EFH_VDI_4100_2012_10_SST_I = 30;
    const EFH_VDI_4100_2012_10_SST_II = 25;
    const EFH_VDI_4100_2012_10_SST_III = 22;

    if (!results) {
        return null;
    }

    const korrekturWerte = getKorrekturWerte(state);
    return {
        ...results,
        // korrekturwerte aufaddieren
        LAF_DIN_angrenzenderRaumMitKorrekturWerten: Math.round(results.LAF_DIN_angrenzenderRaum + korrekturWerte.seitlich),
        LAF_DIN_diagonalDarunterliegenderRaumMitKorrekturWerten: Math.round(results.LAF_DIN_diagonalDarunterliegenderRaum + korrekturWerte.diagonal),
        LAF_VDI_mitGeraeuschenImAngrenzendenRaumMitKorrekturWerten: Math.round(results.LAF_VDI_mitGeraeuschenImAngrenzendenRaum + korrekturWerte.seitlich),
        LAF_VDI_ohneGeraeuscheImAngrenzendenRaumMitKorrekturWerten: Math.round(results.LAF_VDI_ohneGeraeuscheImAngrenzendenRaum + korrekturWerte.seitlich),
        LAF_VDI_mitGeraeuschenImDiagonalDarunterliegendemRaumMitKorrekturWerten:
            Math.round(results.LAF_VDI_mitGeraeuschenImDiagonalDarunterliegendemRaum + korrekturWerte.diagonal),
        LAF_VDI_ohneGeraeuscheImDiagonalDarunterliegendenRaumMitKorrekturWerten:
            Math.round(results.LAF_VDI_ohneGeraeuscheImDiagonalDarunterliegendenRaum + korrekturWerte.diagonal),
        // din normen erfüllt?
        MFH_DIN_409_1_2016_07: results.LAF_DIN_diagonalDarunterliegenderRaumMitKorrekturWerten <= MFH_DIN_409_1_2016_07,
        MFH_DIN_4109_BEIBLATT_2_1989_11: results.LAF_DIN_diagonalDarunterliegenderRaumMitKorrekturWerten <= MFH_DIN_4109_BEIBLATT_2_1989_11,
        MFH_VDI_4100_2012_10_SST_I: results.LAF_VDI_ohneGeraeuscheImDiagonalDarunterliegendenRaumMitKorrekturWerten <= MFH_VDI_4100_2012_10_SST_I,
        MFH_VDI_4100_2012_10_SST_II: results.LAF_VDI_ohneGeraeuscheImDiagonalDarunterliegendenRaumMitKorrekturWerten <= MFH_VDI_4100_2012_10_SST_II,
        MFH_VDI_4100_2012_10_SST_III: results.LAF_VDI_ohneGeraeuscheImDiagonalDarunterliegendenRaumMitKorrekturWerten <= MFH_VDI_4100_2012_10_SST_III,
        EFH_VDI_4100_2012_10_SST_I: results.LAF_VDI_ohneGeraeuscheImDiagonalDarunterliegendenRaumMitKorrekturWerten <= EFH_VDI_4100_2012_10_SST_I,
        EFH_VDI_4100_2012_10_SST_II: results.LAF_VDI_ohneGeraeuscheImDiagonalDarunterliegendenRaumMitKorrekturWerten <= EFH_VDI_4100_2012_10_SST_II,
        EFH_VDI_4100_2012_10_SST_III: results.LAF_VDI_ohneGeraeuscheImDiagonalDarunterliegendenRaumMitKorrekturWerten <= EFH_VDI_4100_2012_10_SST_III,
        EB_VDI_4100_2012_10_SST_EB_I: results.LAF_VDI_ohneGeraeuscheImDiagonalDarunterliegendenRaumMitKorrekturWerten <= EB_VDI_4100_2012_10_SST_EB_I,
        EB_VDI_4100_2012_10_SST_EB_II: results.LAF_VDI_ohneGeraeuscheImDiagonalDarunterliegendenRaumMitKorrekturWerten <= EB_VDI_4100_2012_10_SST_EB_II,
        imgDescriptions: SVG_DATA[results.filenameWithoutExtension].text,
        bubbleDescriptions: getBubbleDescriptions(state, SVG_DATA[results.filenameWithoutExtension].text),
    };
};

const getGroupBelongings = state => {
    const group = getInstallationssystemChoices(state).filter(choice => choice.value === state.choices.installationssystem);

    if (0 === group.length) {
        return null;
    }

    return group[0].group;
};

/**
 * Fetch all possible combinations of Anschlussleitungen and Fallleitungen
 */
export const getPossibleRohrleitungen = state => {
    let wichFallLeitungIsDisabled = [];
    switch (getAbwasserAnschlussLeitungValue(state).value) {
        case Store.GEBERIT_SILENT_PRO:
            wichFallLeitungIsDisabled = [Store.GEBERIT_SILENT_PRO, Store.GEBERIT_SILENT_DB20];
            break;
        case Store.GEBERIT_SILENT_DB20:
            wichFallLeitungIsDisabled = [Store.GEBERIT_SILENT_PRO, Store.GEBERIT_SILENT_DB20];
            break;
        case Store.GEBERIT_SILENT_PP:
            wichFallLeitungIsDisabled = [Store.GEBERIT_SILENT_PRO, Store.GEBERIT_SILENT_DB20, Store.GEBERIT_SILENT_PP];
            break;
    }

    let wichAnschlussLeitungIsDisabled = [];
    switch (getAbwasserFallLeitungValue(state).value) {
        case Store.GEBERIT_SILENT_PRO:
            wichAnschlussLeitungIsDisabled = [Store.GEBERIT_SILENT_PRO, Store.GEBERIT_SILENT_DB20, Store.GEBERIT_SILENT_PP];
            break;
        case Store.GEBERIT_SILENT_DB20:
            wichAnschlussLeitungIsDisabled = [Store.GEBERIT_SILENT_PRO, Store.GEBERIT_SILENT_DB20, Store.GEBERIT_SILENT_PP];
            break;
        case Store.GEBERIT_SILENT_PP:
            wichAnschlussLeitungIsDisabled = [Store.GEBERIT_SILENT_PP];
            break;
    }

    return {
        wichAnschlussLeitungIsDisabled,
        wichFallLeitungIsDisabled,
    };
};

/**
 * calculates korrekturwerte based upon currently selected values
 */
export const getKorrekturWerte = state => {
    const steinsorteValue = state.choices.steinsorte;
    const wandstaerkeValue = state.choices.wandstaerke;
    const putzValue = state.choices.putz;

    // geberit Basiswand hat per default einen korrekturwert welcher Wert das sein wird bekommen wir noch mitgeteilt

    if (steinsorteValue === Store.STEINSORTE_BASISWAND_GEBERIT && putzValue) {
        return {
            seitlich: 2,
            diagonal: 2,
        };
    } else if (steinsorteValue === Store.STEINSORTE_BASISWAND_GEBERIT) {
        return {
            seitlich: 0,
            diagonal: 0,
        };
    }

    if ('undefined' === typeof KORREKTURWERTE[steinsorteValue] || 'undefined' === typeof KORREKTURWERTE[steinsorteValue][wandstaerkeValue]) {
        return {
            seitlich: 0,
            diagonal: 0,
        };
    }

    const [seitlichOhnePutz, diagonalOhnePutz, seitlichMitPutz, diagonalMitPutz, flaechengewichtOhnePutz, flaechengewichtMitPutz] = KORREKTURWERTE[steinsorteValue][wandstaerkeValue];

    if (putzValue) {
        return {
            seitlich: seitlichMitPutz,
            diagonal: diagonalMitPutz,
            flaechengewicht: flaechengewichtMitPutz,
        };
    } else {
        return {
            seitlich: seitlichOhnePutz,
            diagonal: diagonalOhnePutz,
            flaechengewicht: flaechengewichtOhnePutz,
        };
    }
};

/**
 * Creates a valid choices combination
 */
export const educatedGuessChoices = ({
    installationssystem = null,
    wandaufbau = null,
    steinsorte = null,
    wandstaerke = null,
    trinkwasserSteigstrang = null,
    trinkwasserAnschlussleitung = null,
    abwasserFallleitung = null,
    abwasserAnschlussleitung = null,
} = {}) => {
    const fakeState = {
        choices: {
            installationssystem,
            wandaufbau,
            steinsorte,
            wandstaerke,
            trinkwasserSteigstrang,
            trinkwasserAnschlussleitung,
            abwasserFallleitung,
            abwasserAnschlussleitung,
            putz: false,
        },
    };

    let forceWandaufbau = false,
        forceSteinsorte = false,
        forceWandstaerke = false;

    const valueOfFirstElementOrNull = elements => (elements.length > 0 ? elements[0].value : null);

    if (null === fakeState.choices.installationssystem) {
        fakeState.choices.installationssystem = valueOfFirstElementOrNull(getInstallationssystemChoices(fakeState));
        forceWandaufbau = true;
    }
    if (null === fakeState.choices.wandaufbau || forceWandaufbau) {
        fakeState.choices.wandaufbau = valueOfFirstElementOrNull(getWandaufbauChoices(fakeState));
        forceSteinsorte = true;
    }
    if (null === fakeState.choices.steinsorte || forceSteinsorte) {
        fakeState.choices.steinsorte = valueOfFirstElementOrNull(getSteinsorteChoices(fakeState));
        forceWandstaerke = true;
    }
    if (null === fakeState.choices.wandstaerke || forceWandstaerke) {
        fakeState.choices.wandstaerke = valueOfFirstElementOrNull(getWandstaerkeChoices(fakeState));
    }

    if (null === fakeState.choices.trinkwasserSteigstrang) {
        fakeState.choices.trinkwasserSteigstrang = Store.GEBERIT_MAPRESS;
    }

    if (null === fakeState.choices.trinkwasserAnschlussleitung) {
        fakeState.choices.trinkwasserAnschlussleitung = Store.GEBERIT_MAPRESS;
    }

    if (Store.GEBERIT_SILENT_PP === fakeState.choices.abwasserFallleitung) {
        fakeState.choices.abwasserAnschlussleitung = Store.GEBERIT_SILENT_PP;
    }

    if (null === fakeState.choices.abwasserFallleitung) {
        fakeState.choices.abwasserFallleitung = Store.GEBERIT_SILENT_PRO;
    }

    if (null === fakeState.choices.abwasserAnschlussleitung) {
        fakeState.choices.abwasserAnschlussleitung = Store.GEBERIT_SILENT_PRO;
    }

    return fakeState.choices;
};

export const isTranslationAvalible = state => Object.keys(state.intl.messages).length > 0;

export const getInstallationssystemChoices = state => {
    return Object.keys(Store.INSTALLATIONSSYSTEM_CHOICES).map(value => ({
        value,
        ...Store.INSTALLATIONSSYSTEM_CHOICES[value],
    }));
};

const getInstallationssystemValue = state => getInstallationssystemChoices(state).find(choice => choice.value === state.choices.installationssystem) || null;

export const getWandaufbauChoices = state => {
    const group = getGroupBelongings(state);
    return Object.keys(Store.WANDAUFBAU_CHOICES)
        .map(value => ({
            value,
            ...Store.WANDAUFBAU_CHOICES[value],
        }))
        .filter(choice => choice.belongsToGroups.indexOf(group) > -1);
};
const getWandaufbauValue = state => getWandaufbauChoices(state).find(choice => choice.value === state.choices.wandaufbau) || { group: null };

export const getSteinsorteChoices = state => {
    const wandaufbau = getWandaufbauValue(state);
    return Object.keys(Store.STEINSORTE_CHOICES)
        .map(value => ({
            value,
            ...Store.STEINSORTE_CHOICES[value],
        }))
        .filter(choice => choice.belongsToGroups.indexOf(wandaufbau.group) > -1);
};
const getSteinsorteValue = state => getSteinsorteChoices(state).find(choice => choice.value === state.choices.steinsorte) || null;

export const getWandstaerkeChoices = state => {
    const wandaufbau = getWandaufbauValue(state);
    const steinsorte = getSteinsorteValue(state);

    const isWandstaerkeInWandaufbau = choice => choice.belongsToGroups.indexOf(wandaufbau.group) > -1;
    const isWandstaerkeInSteinsorte = choice =>
        steinsorte && steinsorte.wandstaerken !== null && (0 === steinsorte.wandstaerken.length || steinsorte.wandstaerken.indexOf(choice.value) > -1);

    return Object.keys(Store.WANDSTAERKE_CHOICES)
        .map(value => ({
            value,
            ...Store.WANDSTAERKE_CHOICES[value],
        }))
        .filter(choice => isWandstaerkeInWandaufbau(choice) && isWandstaerkeInSteinsorte(choice));
};

const getWandstaerkeValue = state => getWandstaerkeChoices(state).find(choice => choice.value === state.choices.wandstaerke) || null;

export const isPutzEnabled = state => {
    if (null === state.choices.steinsorte) {
        return false;
    }

    return getSteinsorteValue(state).group === Store.GROUP__TRIANGLE_YELLOW;
};

export const getTrinkwasserSteigstrangChoices = state => {
    return Object.keys(Store.TRINKWASSER_STEIGSTRANG_CHOICES).map(value => ({
        value,
        ...Store.TRINKWASSER_STEIGSTRANG_CHOICES[value],
    }));
};

const getTrinkwasserSteigstrangValue = state => getTrinkwasserSteigstrangChoices(state).find(choice => choice.value === state.choices.trinkwasserSteigstrang);

export const getTrinkwasserAnschlussleitungChoices = state => {
    return Object.keys(Store.TRINKWASSER_ANSCHLUSSLEITUNG_CHOICES).map(value => ({
        value,
        ...Store.TRINKWASSER_ANSCHLUSSLEITUNG_CHOICES[value],
    }));
};

const getTrinkwasserAnschlussLeitungValue = state => {
    return getTrinkwasserAnschlussleitungChoices(state).find(choice => choice.value === state.choices.trinkwasserAnschlussleitung);
};

export const getAbwasserFallleitungChoices = state => {
    return Object.keys(Store.ABWASSER_FALLLEITUNG_CHOICES).map(value => ({
        value,
        ...Store.ABWASSER_FALLLEITUNG_CHOICES[value],
    }));
};

const getAbwasserFallLeitungValue = state => getAbwasserFallleitungChoices(state).find(choice => choice.value === state.choices.abwasserFallleitung);

export const getAbwasserAnschlussleitungChoices = state => {
    return Object.keys(Store.ABWASSER_ANSCHLUSSLEITUNG_CHOICES).map(value => ({
        value,
        ...Store.ABWASSER_ANSCHLUSSLEITUNG_CHOICES[value],
    }));
};

const getAbwasserAnschlussLeitungValue = state => {
    return getAbwasserAnschlussleitungChoices(state).find(choice => choice.value === state.choices.abwasserAnschlussleitung);
};
